const upcomingCollectionsSettings = {
    dots: false,
    className: "center",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
        {
          breakpoint: 1114,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
        },
    ]
};


const newCollectionsSettings = {
    dots: false,
    className: "center",
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
    {
    breakpoint: 1550,
    settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
    }
    },
    {
        breakpoint: 1400,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        }
    },
    {
        breakpoint: 800,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        }
    },
    {
        breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        }
    },
]
};

const auctionSettings = {
  dots: false,
  className: "center",
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  infinite: true,
  responsive: [
  {
  breakpoint: 1250,
  settings: {
      slidesToShow: 5,
      slidesToScroll: 1,
  }
  },
  {
      breakpoint: 940,
      settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
      }
  },
  {
      breakpoint: 800,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
      }
  },
  {
      breakpoint: 550,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
      }
  },
]
};

export {upcomingCollectionsSettings, newCollectionsSettings, auctionSettings};